@import '../../../constants/spacing.module.less';

.has-applicable-recommendation {
  border-color: var(--fulfillment-plans-rate-recommendation--border-color-light);
  background: var(--fulfillment-plans-rate-recommendation--background-color-light);
}

.original-cost {
  min-width: 80px;
  text-align: end;
}

.recommendation-and-cost {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1;
  gap: @space-8;
}
